import React, { useEffect, useState } from "react";
import "./signIn.css";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import {
  auth,
  logInWithEmailAndPassword,
  sendPasswordReset,
} from "../../../firebase/firebase";
import { Button, Modal } from "react-bootstrap";
const SignIn = () => {
  const navigate = useNavigate();
  const [userisLogged, setUserisLogged] = useState();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailerror, setEmailError] = useState(false);
  const [passworderror, setPasswordError] = useState(false);
  const [emailForReset, setEmailForReset] = useState("");

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
        playVideo();
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        setUserisLogged(user);
      }
    });
    return () => unsubscribe();
  }, []);
  const Validation = () => {
    let error = false;
    if (email == "") {
      console.log("email");
      setEmailError(true);
      error = true;
    } else {
      setEmailError(false);
      error = false;
    }
    if (password == "") {
      console.log("pss");
      setPasswordError(true);
      error = true;
    } else {
      setPasswordError(false);
      error = false;
    }
    return error;
  };
  const signIn = async () => {
    const validation = Validation();
    if (validation) {
    } else {
      await logInWithEmailAndPassword(email, password)
        .then((res) => {
          console.log(res.userCred.user.emailVerified);
          // if (res.userCred.user.emailVerified) {

          // }
          if (res.success) {
            // navigate("/");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const forgotPassword = () => {
    // setShow(true)
    sendPasswordReset(emailForReset);
  };

  useEffect(() => {
    console.log(userisLogged);
  }, [userisLogged]);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      signIn();
    }
  };
  const playVideo = () => {
    const videoElement = document.getElementById("myvid");
    if (videoElement) {
      videoElement.play();
    }
  };
  const handleGoogle = () => {};
  const handleFacebook = () => {};
  return (
    <div>
      <div className="singin-page">
        <div className="layer-shadow"></div>
        <div className="signIn-form">
          <div className="signIn-form-content">
            <img
              src="\assets\images\signin-logo.png"
              // onClick={playVideo}
              alt="singin-background-img"
            />
            <h1>Sign In</h1>
            <div className="input-box">
              <Icon
                icon="clarity:user-solid"
                color="white"
                width="22"
                height="28"
                className="ico"
              />
              <input
                type="email"
                name=""
                placeholder="Username or Email"
                id=""
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <p
              style={{
                margin: "0",
                color: "red",
                display: emailerror ? "flex" : "none",
                justifyContent: "center",
              }}
            >
              Please Enter Valid Email
            </p>
            <div className="input-box">
              <Icon
                icon="mdi:password"
                color="white"
                width="20"
                height="28"
                className="ico"
              />
              <input
                type="password"
                name=""
                placeholder="Password"
                id=""
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />
            </div>
            <p
              style={{
                margin: "0",
                color: "red",
                display: passworderror ? "flex" : "none",
                justifyContent: "center",
              }}
            >
              Please Enter Valid Password
            </p>
            <p className="cursor-pointer" onClick={handleShow}>
              Forgot Password?
            </p>

            <h4 className="social-media-tit">Create Account Using</h4>
            <div className="social-media">
              <div className="cursor-pointer" onClick={handleGoogle}>
                <img
                  className="sign-up-google"
                  src="../../../../assets/images/signupgoogle.svg"
                  alt=""
                />
              </div>

              <div className="cursor-pointer" onClick={handleFacebook}>
                <img
                  className="sign-up-google"
                  src="../../../../assets/images/signupfacebook.svg"
                  alt=""
                />
              </div>
            </div>

            <button className="signin-btn" onClick={signIn}>
              Sign In
            </button>
            <div className="f-pass">
              <p>OR</p>
            </div>
            <div className="create-account-btn">
              <button
                onClick={() => {
                  navigate("/sign-up");
                }}
              >
                Create Account
              </button>
            </div>
          </div>
        </div>
        {/* Poster code */}
        <div className="sign-video">
          <video loop muted playsInline id="myvid">
            <source
              src="../../../../assets/videos/SignInPage_Background.mp4"
              width="250"
              height="50"
              poster="\assets\images\SignInPage_StillImage.jpg"
              type="video/mp4"
            />
          </video>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        centered
        className="password-modal"
      >
        <Modal.Header className="modal-header" closeButton>
          <Modal.Title className="modal-title">
            <h2 className="body-medium ">Forgot Password</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modal-body">
          <p className="para text-light-grey d-flex align-items-center justify-content-center">
            Enter your email to get reset link
          </p>
          <input
            type="email"
            name=""
            id=""
            placeholder="Example@mail.com"
            onChange={(e) => {
              setEmailForReset(e.target.value);
            }}
          />
        </Modal.Body>

        <Button
          className="save w-75 m-auto mb-5 mt-5"
          variant="secondary"
          onClick={forgotPassword}
        >
          Reset Password
        </Button>
      </Modal>
    </div>
  );
};

export default SignIn;
